<script setup>
import {useDropzone} from "vue3-dropzone";
import {useAttrs} from 'vue';

const emit = defineEmits(['onDrop']);

const onDrop = (acceptFiles, rejectReasons) => {
  emit('onDrop', acceptFiles, rejectReasons);
};

const attrs = useAttrs();

// See options available here: https://github.com/Yaxian/vue3-dropzone/tree/main#options
const { getRootProps, getInputProps, isDragActive, open, acceptedFiles, fileRejections } = useDropzone({ onDrop, ...attrs });
</script>

<template>
  <div>
    <div class="dropzone" v-bind="getRootProps()">
      <input v-bind="getInputProps()" />
      <p v-if="isDragActive">Drop the files here...</p>
      <p v-else>{{ $attrs.placeholder || "Drag 'n' drop some files here, or click to select files"}}</p>
    </div>
    <div class="m-2">
      <ul class="ml-4" v-for="file in acceptedFiles" :key="file.path">
        <li>{{ file.name }}</li>
      </ul>
    </div>
    <div class="m-2">
      <div v-for="rejections in fileRejections">
        <div v-for="error in rejections.errors">
          <p style="color: red">{{ error.message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .dropzone {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: #eeeeee;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
    cursor: pointer;
  }
</style>
